import { Build } from '@stencil/core';

const init = async () => {
	if (Build.isDev) {
		const { initDevMode } = await import('../dev/dev-mode');
		await initDevMode();
	}
};

export default init;
